export default __webpack_public_path__ + "static/media/1860.bb03dfff.png";